import * as React from 'react';
import styled from 'styled-components';
import slugify from 'slugify';
import { SectionHeading, Text } from '@components/Typography';
import { StyledContent } from '@components/PersonModal';
import { IconSVG } from '@components/IconSVG';
import RegisterBtn from '@components/RegisterBtn';

type Props = GatsbyTypes.SessionsJson & {
  mode: string;
  copy: GatsbyTypes.MicrocopyFragment['registration'];
};

const StyledImageWrapper = styled.div`
  height: 95px;
  width: 95px;
  margin: 0 auto;

  @media (min-height: 729px) {
    height: 172px;
    width: 172px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 95px;
    width: 95px;
  }

  svg {
    height: inherit;
    width: inherit;
  }
`;

const StyledSessionContent = styled(StyledContent)`
  justify-content: flex-start;

  h2 {
    margin: 2rem auto 1rem;
  }
`;

const Description = styled(Text).attrs({
  mode: 'dark',
  size: 'xs',
  as: 'p',
})`
  i {
    font-style: italic;
  }
`;

const EventModal = ({ title, description, iconName, brandLiveUrl, mode, copy }: Props): JSX.Element => {
  return (
    <>
      <StyledSessionContent data-link-id={slugify(title?.toLowerCase())}>
        <StyledImageWrapper>
          <IconSVG variant={iconName && iconName} />
        </StyledImageWrapper>
        <SectionHeading mode="dark" as="h2">
          {title}
        </SectionHeading>
        {description && <Description dangerouslySetInnerHTML={{ __html: description }} />}
      </StyledSessionContent>
      <RegisterBtn sessionId={brandLiveUrl} type="event">
        {copy[mode]}
      </RegisterBtn>
    </>
  );
};

export default EventModal;
